var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-outline-primary",class:{disabled : _vm.disabled},on:{"click":_vm.handleClick}},[(_vm.loading)?_c('span',[_vm._v("loading")]):_c('span',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }